var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$route.name != 'login' && _vm.$route.name != 'signup')?_c('AppHeader'):_vm._e(),(
      _vm.$store.getters.isSupp &&
      _vm.$store.getters.loggedin &&
      _vm.$route.meta.requiresAuth &&
      !_vm.$route.meta.noMenu
    )?_c('AppAside'):_vm._e(),_c('v-main',[(
        _vm.$route.name != 'login' &&
        _vm.$route.name != 'signup' &&
        !_vm.$store.getters.isSupp
      )?_c('v-container',[_c('AdminMenu')],1):_vm._e(),_c('router-view'),_c('v-snackbar',{attrs:{"timeout":"6000000","width":"auto","right":""},scopedSlots:_vm._u([{key:"action",fn:function({ attrs }){return [_c('v-icon',_vm._b({attrs:{"color":"white"}},'v-icon',attrs,false),[_vm._v("wifi_off")])]}}]),model:{value:(_vm.$store.state.connection_snack),callback:function ($$v) {_vm.$set(_vm.$store.state, "connection_snack", $$v)},expression:"$store.state.connection_snack"}},[_vm._v(" لايوجد اتصال بالأنترنت ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }